import React, {Fragment} from "react";

// The soft hyphens (\u00AD) let the long German words break on a phone-width screen;
// CSS hyphens:auto is not enough, since not every browser ships a German dictionary.
const STEPS = ["Produkt\u00ADauswahl", "Verifi\u00ADzierung & Zahlung", "Bestell\u00ADbestätigung"];

const CheckoutSteps = ({currentStep}) => (
    <div className="flex items-start justify-center gap-1 md:gap-8">
        {STEPS.map((label, index) => {
            const step = index + 1;
            const reached = step <= currentStep;

            return (
                <Fragment key={label}>
                    {index > 0 && (
                        <div className={`w-4 md:w-10 h-1 mt-4 shrink-0 ${reached ? "bg-pegasusPurple" : "bg-gray-300"}`}></div>
                    )}
                    <div className="flex flex-col items-center flex-1 min-w-0 md:flex-none">
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold ${reached ? "bg-pegasusPurple text-white" : "bg-gray-300 text-gray-500"}`}>
                            {step}
                        </div>
                        <span className={`mt-2 text-xs md:text-sm text-center ${step === currentStep ? "font-semibold text-gray-800" : "font-medium text-gray-500"}`}>
                            {label}
                        </span>
                    </div>
                </Fragment>
            );
        })}
    </div>
);

export default CheckoutSteps;
